module.exports = __webpack_public_path__ + "static/circularstd-book-36b95d1079e11cc557e0a868171626d7.woff2";